module.exports = __webpack_public_path__ + "img/DR.89a916d3.png";